<template>
  <v-container fluid>
    <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>
  <v-row class="mb-2">
      <v-col cols="12" class="d-flex gap-2 align-center">
        
        <v-btn color="primary" class="mb-2" @click="seleccionarHorizonteCompleto">
          {{this.$t('simulacion.modulo.resultado.horizonte_completo')}}
        </v-btn>
        
      <v-btn color="secondary" class="ml-2 mb-2" @click="cargarGraficoH2Production">
        {{this.$t('simulacion.modulo.resultado.cargar_grafico')}}
      </v-btn>
      </v-col>
    </v-row>
    <div class="contenedor-personalizado">
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="periodoTipo"
          :items="periodoTipos"
          item-title="label"
          item-value="value"
          :label="$t('simulacion.modulo.resultado.temporal.filtros.tipo_periodo')"
          outlined density="compact" variant="outlined"
        />

        <!-- Selector de periodos -->
        <v-select
          v-if="periodoTipo !== 'anual' && periodoTipo !== 'semanal'"
          v-model="periodoSeleccionado"
          :items="periodoTipo === 'mensual' ? i18nMeses : i18nTrimestres"
          item-title="label"
          item-value="value"
          :label="$t('simulacion.modulo.resultado.temporal.filtros.seleccionar_periodos')"
          multiple chips outlined density="compact" variant="outlined"
        />

        <v-select
          v-if="periodoTipo === 'semanal'"
          v-model="mesesSeleccionados"
          :items="i18nMeses"
          item-title="label" item-value="value"
          :label="$t('simulacion.modulo.resultado.temporal.filtros.seleccionar_mes')"
          multiple outlined density="compact" variant="outlined"
        />

        <v-select
          v-if="periodoTipo === 'semanal'"
          v-model="semanasSeleccionadas"
          :items="i18nSemanas"
          item-title="label" item-value="value"
          :label="$t('simulacion.modulo.resultado.temporal.filtros.seleccionar_semana')"
          multiple outlined density="compact" variant="outlined"
        />

        <v-select
          v-if="periodoTipo === 'semanal'"
          v-model="diasSeleccionados"
          :items="i18nDiasSemana"
          item-title="label" item-value="value"
          :label="$t('simulacion.modulo.resultado.temporal.filtros.seleccionar_dias_semana')"
          multiple chips outlined density="compact" variant="outlined"
        />

        <v-select
          v-model="aniosSeleccionados"
          :items="aniosDisponibles"
          :label="$t('simulacion.modulo.resultado.temporal.filtros.seleccionar_anios')"
          multiple chips outlined density="compact" variant="outlined"
        />
      </v-col>
<v-col cols="3" sm="3">
                      <v-btn  color="primary"   @click="aplicarFiltros">
                        {{$t('comun.aplicar')}} 
                      </v-btn>
                    </v-col>

    </v-row>
    
    
</div><br><br>
    <v-row>
      <v-col cols="12">
        <ComponenteLoading :is-loading="loadingProd" :message="mensaje_loading_prod" />
          <ComponenteGrafica
           :key="chartKey"
            v-if="!loadingProd"
            :options="graficaProduccionHidrogeno"
            ref="grafProdTotal"
            @rendered="onProdRendered"
            @error="onProdError"
          />
      </v-col>
    </v-row>

   <!-- <v-row>
      <v-col cols="12">
        <ComponenteGrafica :options="graficaDemandaHidrogeno" />
      </v-col>
    </v-row> -->
  <v-row>
      <v-col cols="12">
       
        <ComponenteLoading :is-loading="loadingH2" :message="mensaje_loading_h2" />
          <ComponenteGrafica
            v-if="showGraficoH2Production"   
            :key="h2ChartKey"
            :options="graficaH2Production"
            ref="grafH2Origen"
            @rendered="onH2Rendered"
            @error="onH2Error"
          />
      </v-col>
    </v-row>
    <!-- Tabla debajo del gráfico -->
<v-row v-if="showGraficoH2Production && origenHayDatos">
  <v-col cols="12">
    <div class="tabla-container">
    <v-table class="tabla-origen" density="compact">
      <thead>
        <tr>
          <th></th>
          <th v-for="y in tablaH2Production.labels" :key="'h-'+y" class="text-right">
            {{ y }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="r in tablaH2Production.rows" :key="r.label">
          <td class="col-label">
            <span class="d-inline-flex align-center" style="gap:8px">
              <span :style="swatchStyle(r)"></span>
              {{ r.label }}
            </span>
          </td>
          <td v-for="(v,i) in r.values" :key="r.label+'-'+i" class="text-right">
            {{ (v) }}
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
  </v-col>
</v-row>
  </v-container>
</template>

<script>
import ComponenteGrafica from './ComponenteGrafica.vue';
import ComponenteLoading from './ComponenteLoading.vue';

export default {
  props: {
    datos_temporales: { type: Array, required: true },
    //resultado_economico: { type: Object, required: true },
    datos_generales: { type: Object, required: true },
    resultado_variables: { type: Array, required: true },
    datos_anuales:    { type: Array, required: true },
  },

  data() {
    return {
      periodoTipo: 'mensual',
      periodoTipoAplicado: 'mensual',
      periodosSemanales: ['Semana 1', 'Semana 2', 'Semana 3', 'Semana 4'],
      periodoSeleccionado: [],
      mesesSeleccionados: [],
      semanasSeleccionadas: [],
      diasSeleccionados: [],
      diasSemana: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
      aniosDisponibles: [],
      aniosSeleccionados: [],
      periodosMensuales: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      periodosTrimestrales: ['T1', 'T2', 'T3', 'T4'],
      showGraficoH2Production: false,
      loading: false,
      loadingProd: false,        
      loadingH2: false,          
      mensaje_loading_prod: "",
      mensaje_loading_h2: "", 
      datosFiltradosAplicados: [],
      suspendAutoRender: false,
      
    loadingTimeout: null,
    h2LoadingTimeout: null,
    mountedReady: false,
    chartKey: 0,
    };
  },

  computed: {
    
    periodoTipos() {
    const base = 'simulacion.modulo.resultado.temporal.periodos';
    return [
      { value: 'mensual',    label: this.$t(`${base}.mensual`) },
      { value: 'trimestral', label: this.$t(`${base}.trimestral`) },
      { value: 'anual',      label: this.$t(`${base}.anual`) },
      { value: 'semanal',    label: this.$t(`${base}.semanal`) },
    ];
  },

  // Listas traducidas (solo presentación)
  i18nMeses() {
    const base = 'simulacion.modulo.resultado.temporal.mes';
    const labels = [
      this.$t(`${base}.enero`), this.$t(`${base}.febrero`), this.$t(`${base}.marzo`), this.$t(`${base}.abril`),
      this.$t(`${base}.mayo`),  this.$t(`${base}.junio`),   this.$t(`${base}.julio`), this.$t(`${base}.agosto`),
      this.$t(`${base}.septiembre`), this.$t(`${base}.octubre`), this.$t(`${base}.noviembre`), this.$t(`${base}.diciembre`)
    ];
    return labels.map((label, idx) => ({ value: idx, label }));
  },

  // Trimestres: value 0..3, label traducida
  i18nTrimestres() {
    const base = 'simulacion.modulo.resultado.temporal.trimestre';
    const labels = [this.$t(`${base}.t1`), this.$t(`${base}.t2`), this.$t(`${base}.t3`), this.$t(`${base}.t4`)];
    return labels.map((label, idx) => ({ value: idx, label }));
  },

  // Semanas: value 1..4
  i18nSemanas() {
    const base = 'simulacion.modulo.resultado.temporal.semana';
    return [1,2,3,4].map(n => ({ value: n, label: this.$t(`${base}.${n}`) }));
  },

  // Días: value 0..6 (lunes=0)
  i18nDiasSemana() {
    const base = 'simulacion.modulo.resultado.temporal.dia_semana';
    const labels = [
      this.$t(`${base}.lunes`), this.$t(`${base}.martes`), this.$t(`${base}.miercoles`),
      this.$t(`${base}.jueves`), this.$t(`${base}.viernes`), this.$t(`${base}.sabado`),
      this.$t(`${base}.domingo`)
    ];
    return labels.map((label, idx) => ({ value: idx, label }));
  },
    origenHayDatos() {
  const opt = this.graficaH2Production;
  if (!opt) return false;
  // muestra si hay labels o si alguna serie tiene datos
  const hasXAxis = Array.isArray(opt.xAxis?.data) && opt.xAxis.data.length > 0;
  const hasSeries = Array.isArray(opt.series) && opt.series.some(s => Array.isArray(s.data) && s.data.length > 0);
  return hasXAxis || hasSeries;
},
     tieneProduccion() {
    return this.datosFiltrados.length > 0;
  },
  tieneOrigenAnual() {
    return Array.isArray(this.datos_anuales) && this.datos_anuales.length > 0;
  },
  H2ProductionAgrupado() {
  const y0 = Number(this.datos_generales?.anio_inicio);
  const y1 = Number(this.datos_generales?.anio_fin);
  if (!Number.isFinite(y0) || !Number.isFinite(y1)) {
    console.warn('[H2ProductionAgrupado] anio_inicio / anio_fin no válidos', y0, y1);
    return { labels: [], gridV: [], gridR: [], ppa: [], res: [], totalRFNBO: [], totalE: [], totalAll: [] };
  }

  // Parser
  const toNumber = (v) => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
    let s = String(v).trim().replace(/%/g, '');
    if (/,\d{1,}$/.test(s)) { s = s.replace(/\./g, '').replace(/,/g, '.'); } else { s = s.replace(/,/g, ''); }
    const x = Number(s);
    return Number.isFinite(x) ? x : 0;
  };
  const n = toNumber;

  const sumPPA = (r) =>
    n(r.EH2_ppa1) + n(r.EH2_ppa2) + n(r.EH2_ppa3) +
    n(r.EH2_PPA1) + n(r.EH2_PPA2) + n(r.EH2_PPA3);

  // helper para coger clave
  const firstNum = (r, keys) => {
    for (const k of keys) {
      if (k in r && r[k] != null && r[k] !== '') return n(r[k]);
    }
    return 0;
  };

  // Índice por año
  const byYear = new Map();
  const debugRows = [];

  for (const r of (Array.isArray(this.datos_anuales) ? this.datos_anuales : [])) {
    const rawYear = (r.anio ?? r.year ?? r.Anio ?? r.YEAR ?? r.Year);
    const y = n(rawYear);
    if (!Number.isFinite(y) || y < y0 || y > y1) continue;

    const rawRes   = r.res ?? r.RES ?? r['RES (%)'];
    const rawEMCDV = r.E_MCDV;
    const rawEELEC = r.E_ELEC;

    byYear.set(y, r);

    debugRows.push({
      YEAR: rawYear,
      'HEQ_ELL raw': r.HEQ_ELL, 'HEQ_ELL num': n(r.HEQ_ELL),
      'HEQ_ELV raw': r.HEQ_ELV, 'HEQ_ELV num': n(r.HEQ_ELV),
      'HEQ_EL raw':  r.HEQ_EL,  'HEQ_EL num':  n(r.HEQ_EL),
      'RES raw': rawRes,        'RES num(0..1)': (() => {
        let x = n(rawRes); if (x > 1) x /= 100; return x;
      })(),
      'E_MCDV raw': rawEMCDV,   'E_MCDV num': n(rawEMCDV),
      'E_ELEC raw': rawEELEC,   'E_ELEC num': n(rawEELEC),
      'EH2_PV':  r.EH2_PV,
      'EH2_EOL': r.EH2_EOL,
      'PPA1': r.EH2_ppa1 ?? r.EH2_PPA1,
      'PPA2': r.EH2_ppa2 ?? r.EH2_PPA2,
      'PPA3': r.EH2_ppa3 ?? r.EH2_PPA3,
    });
  }

  console.log('[H2ProductionAgrupado] Registros anuales usados:');
  console.table(debugRows);

  const labels = [], gridV = [], gridR = [], ppa = [], res = [];
  const totalRFNBO = [], totalE = [], totalAll = [];
  const EPS = 1e-9;

  for (let y = y0; y <= y1; y++) {
    const r = byYear.get(y) || {};
    const rawRes = r.res ?? r.RES ?? r['RES (%)'];

    // HEQ_* (horas anuales)
    const HN = n(r.HEQ_ELL); // No RFNBO
    const HV = n(r.HEQ_ELV); // RFNBO
    const HT = n(r.HEQ_EL) || (HN + HV);

    // RES anual (0..1)
    let RESf = n(rawRes);
    if (RESf > 1) RESf /= 100;
    RESf = Math.max(0, Math.min(RESf, 0.999999));

    // E_MCDV y E_ELEC para el nuevo cálculo de GRID si RES >= 0.9
    const EMCDV = firstNum(r, ['E_MCDV']);
    const EELEC = firstNum(r, ['E_ELEC']);

    // Orígenes de energía (ponderación RES / PPA)
    const EPV  = n(r.EH2_PV);
    const EEOL = n(r.EH2_EOL);
    const EPPA = sumPPA(r);
    const den  = EPV + EEOL + EPPA;

    // 1) GRID total
    let GRID;
    if (RESf < 0.9) {
      // Caso 1: RES < 90%
      GRID = HN + (HN * RESf / (1 - RESf));
    } else {
      // Caso 2: RES >= 90%
      // GRID = HEQ_EL * E_MCDV / E_ELEC
      if (EELEC > EPS) {
        GRID = HT * (EMCDV / EELEC);
      } else {
        GRID = 0;
      }
    }
    GRID = Math.max(0, Math.min(GRID, HT));

    // 2) RES (solo la parte RES de RFNBO)
    let RESv = 0;
    if (den > EPS) {
      RESv = (HT - GRID) * ((EPV + EEOL) / den);
      RESv = Math.max(0, RESv);
    }

    // 3) PPA = total - GRID - RES
    let PPAv = Math.max(0, HT - GRID - RESv);

    // Partir GRID en: no RFNBO (abajo) y RFNBO
    const gridNo = Math.min(HN, GRID);
    const gridRf = Math.max(0, GRID - gridNo);

    // PPA/RES sólo en RFNBO
    const ppaNo = 0, resNo = 0;
    let   ppaRf = PPAv, resRf = RESv;

    const rfSum = gridRf + ppaRf + resRf;
    if (Math.abs(rfSum - HV) > 1e-9) {
      const exceso = rfSum - HV;
      if (exceso > 0) {
        const recPPA = Math.min(exceso, ppaRf);
        ppaRf -= recPPA;
        const resto = exceso - recPPA;
        if (resto > 1e-9) resRf = Math.max(0, resRf - resto);
      } else {
        ppaRf += (-exceso);
      }
    }

    const rfnbo = gridRf + ppaRf + resRf;
    const all   = rfnbo + gridNo;

    labels.push(String(y));
    gridV.push(gridNo);     // GRID no RFNBO
    gridR.push(gridRf);     // GRID RFNBO
    ppa.push(ppaNo + ppaRf);
    res.push(resNo + resRf);

    totalRFNBO.push(rfnbo);
    totalE.push(all);
    totalAll.push(all);

    //console.log(`\n[H2ProductionAgrupado] Año ${y}`);
    //console.log('  HN:', HN, 'HV:', HV, 'HT:', HT);
    //console.log('  RESf:', RESf, 'E_MCDV:', EMCDV, 'E_ELEC:', EELEC);
    //console.log('  GRID:', GRID, 'RESv:', RESv, 'PPAv:', PPAv);
  }

  return { labels, gridV, gridR, ppa, res, totalRFNBO, totalE, totalAll };
},



   graficaH2Production() {
    if (!Array.isArray(this.datos_anuales) || !this.datos_anuales.length) {
      if (!Array.isArray(this.datos_temporales) || !this.datos_temporales.length) return {};
    }
    const y0 = Number(this.datos_generales?.anio_inicio);
    const y1 = Number(this.datos_generales?.anio_fin);
    if (!y0 || !y1) return {};

    const { labels, gridV, gridR, ppa, res } = this.H2ProductionAgrupado;
    if (!labels.length) return {};

    // máximo de la suma total por año
    const totals = labels.map((_, i) =>
      (Number(gridV?.[i]) || 0) +
      (Number(gridR?.[i]) || 0) +
      (Number(ppa?.[i])   || 0) +
      (Number(res?.[i])   || 0)
    );
    const maxStack = Math.max(...totals, 0);

    const niceCeil = (x) => {
      if (x <= 0) return 1;
      const exp  = Math.floor(Math.log10(x));
      const base = 10 ** exp;
      const m = x / base;
      const nice = m <= 1 ? 1 : m <= 2 ? 2 : m <= 5 ? 5 : 10;
      return nice * base;
    };
    const yMax = niceCeil(maxStack * 1.10);

    return {
      animation: false,
      title: {
        text: this.$t('simulacion.modulo.resultado.temporal.graficas.h2_origen.titulo'),
        left: 'center',
        top: 10,
        textStyle: { fontSize: 16, fontWeight: 'bold' }
      },
      tooltip: {
        trigger: 'axis',
        valueFormatter: v => `${Number(v).toFixed(2)} hr`
      },
      legend: {
        top: 'bottom',
        //  mismos nombres que las series
        data: ['LowCarbon', 'Grid RFNBO', 'PPA RFNBO', 'RES RFNBO'],
      },
      xAxis: { type: 'category', data: labels },
      yAxis: {
        type: 'value',
        name: 'hr',
        min: 0,
        max: yMax,
        axisLabel: { formatter: v => v.toLocaleString('es-ES') }
      },
      series: [
        // 1. LowCarbon (GRID no RFNBO)
        {
          name: 'LowCarbon',
          type: 'bar',
          stack: 'stack',
          data: gridV,
          itemStyle: {
            color: '#6F8200',       // verde oscuro
            borderColor: '#0F7CB7', // borde azul
            borderWidth: 3
          },
          z: 10
        },

        // 2. Grid RFNBO
        {
          name: 'Grid RFNBO',
          type: 'bar',
          stack: 'stack',
          data: gridR,
          itemStyle: {
            color: '#9CB700',       // verde claro
            borderColor: '#0F7CB7', // borde azul
            borderWidth: 3
          },
          z: 11
        },

        // 3. PPA RFNBO
        {
          name: 'PPA RFNBO',
          type: 'bar',
          stack: 'stack',
          data: ppa,
          itemStyle: {
            color: '#9CB700',       // verde claro
            borderColor: '#F17D36', // borde naranja
            borderWidth: 3
          },
          z: 12
        },

        // 4. RES RFNBO
        {
          name: 'RES RFNBO',
          type: 'bar',
          stack: 'stack',
          data: res,
          itemStyle: {
            color: '#9CB700'        // solo relleno
          },
          z: 13
        }
      ]
    };
  },



  tablaH2Production() {
  const { labels, gridV, gridR, ppa, res } = this.H2ProductionAgrupado;
  const f = x => Number(x).toFixed(4);

  return {
    labels,
    rows: [

      // 1. LowCarbon
      {
        label: 'LowCarbon',
        itemStyle: {
          color: '#6F8200',
          borderColor: '#0F7CB7',
          borderWidth: 2
        },
        values: gridV.map(f)
      },

      // 2. Grid RFNBO
      {
        label: 'Grid RFNBO',
        itemStyle: {
          color: '#9CB700',
          borderColor: '#0F7CB7',
          borderWidth: 2
        },
        values: gridR.map(f)
      },

      // 3. PPA RFNBO
      {
        label: 'PPA RFNBO',
        itemStyle: {
          color: '#9CB700',
          borderColor: '#F17D36',
          borderWidth: 2
        },
        values: ppa.map(f)
      },

      // 4. RES RFNBO
      {
        label: 'RES RFNBO',
        itemStyle: {
          color: '#9CB700'
        },
        values: res.map(f)
      }
    ]
  };
},

    datosTemporalesConFecha() {
      
      return this.datos_temporales.map(d => {
        if (d.fecha) return d;
        if (d.Periodo) {
          return { ...d, fecha: this.periodoToDate(d.Periodo).toISOString() };
        }
        return d;
      });
    },

    datosFiltrados() {
  const datos = this.datosTemporalesConFecha;
  if (!this.aniosSeleccionados.length) return [];

  return datos.filter(d => {
    const fecha = new Date(d.fecha);
    const year  = fecha.getFullYear();
    const mes   = fecha.getMonth();           // 0..11
    const dow   = (fecha.getDay() + 6) % 7;   // lunes=0
    const day   = fecha.getDate();            // 1..31
    const qIdx  = Math.floor(mes / 3);        // 0..3
    const wNum  = Math.min(4, Math.floor((day - 1) / 7) + 1); // 1..4

    if (!this.aniosSeleccionados.includes(year)) return false;

    if (this.periodoTipo === 'anual') return true;

    if (this.periodoTipo !== 'semanal' && !this.periodoSeleccionado.length) return false;

    if (this.periodoTipo === 'mensual') {
      // periodoSeleccionado: array de índices 0..11
      return this.periodoSeleccionado.includes(mes);
    }

    if (this.periodoTipo === 'trimestral') {
      // periodoSeleccionado: array de índices 0..3
      return this.periodoSeleccionado.includes(qIdx);
    }

    if (this.periodoTipo === 'semanal') {
      const mesOk    = !this.mesesSeleccionados.length   || this.mesesSeleccionados.includes(mes);
      const semanaOk = !this.semanasSeleccionadas.length || this.semanasSeleccionadas.includes(wNum);
      const diaOk    = !this.diasSeleccionados.length    || this.diasSeleccionados.includes(dow);
      return mesOk && semanaOk && diaOk;
    }

    return false;
  });
},


    graficaProduccionHidrogeno() {
      if (!this.datosFiltradosAplicados.length) return {};
      const G_H2  = this.agruparDatosPorPeriodo('G_H2');
      const G_H2V = this.agruparDatosPorPeriodo('G_H2V');
      const G_H2L = this.agruparDatosPorPeriodo('G_H2L');
      const root = 'simulacion.modulo.resultado.temporal';

      return {
        tooltip: { trigger: 'axis' },
        legend: { data: [ this.$t(`${root}.series.total_h2`), this.$t(`${root}.series.h2_verde`), this.$t(`${root}.series.h2_low_carbon`) ] },
        xAxis: { type: 'category', data: G_H2.labels },
        yAxis: { type: 'value', name: 'ton H2' },
        series: [
        { name: this.$t(`${root}.series.total_h2`),      type: 'line', areaStyle: {}, data: G_H2.valores },
        { name: this.$t(`${root}.series.h2_verde`),      type: 'line', areaStyle: {}, data: G_H2V.valores },
        { name: this.$t(`${root}.series.h2_low_carbon`), type: 'line', areaStyle: {}, data: G_H2L.valores },
      ]
      };
    },

    graficaDemandaHidrogeno() {
      if (!this.datosFiltrados.length) return {};

      const D_H2VOb = this.agruparDatosPorPeriodo('D_H2VOb');
      const D_H2VOp = this.agruparDatosPorPeriodo('D_H2VOp');
      const D_H2LOb = this.agruparDatosPorPeriodo('D_H2LOb');
      const D_H2LOp = this.agruparDatosPorPeriodo('D_H2LOp');

      return {
        tooltip: { trigger: 'axis' },
        legend: {
          data: [
            'Demanda obligatoria H2 verde',
            'Demanda opcional H2 verde',
            'Demanda obligatoria H2 low carbon',
            'Demanda opcional H2 low carbon'
          ]
        },
        xAxis: { type: 'category', data: D_H2VOb.labels },
        yAxis: { type: 'value', name: 'ton H2' },
        series: [
          { name: 'Demanda obligatoria H2 verde', type: 'bar', stack: 'verde', data: D_H2VOb.valores },
          { name: 'Demanda opcional H2 verde', type: 'bar', stack: 'verde', data: D_H2VOp.valores },
          { name: 'Demanda obligatoria H2 low carbon', type: 'bar', stack: 'grid verde', data: D_H2LOb.valores },
          { name: 'Demanda opcional H2 low carbon', type: 'bar', stack: 'grid verde', data: D_H2LOp.valores },
        ]
      };
    }
  },

  methods: {
    swatchStyle(row) {
  const s = row.itemStyle || {};
  const bg = s.color || row.color || '#999';
  const bw = (s.borderWidth ?? 0);
  const bc = s.borderColor || 'transparent';
  return {
    background: bg,
    border: bw ? `${bw}px solid ${bc}` : 'none',
    display: 'inline-block',
    width: '10px',
    height: '10px'
  };
},
     sumPPA (r) {
    const v = k => Number(r[k]) || 0;
    // suma minúscula y mayúscula si existieran
    return v('EH2_ppa1')+v('EH2_ppa2')+v('EH2_ppa3')
         + v('EH2_PPA1')+v('EH2_PPA2')+v('EH2_PPA3');
  },
     async aplicarFiltros () {
    
    if (this.loadingProd) return;
  this.loadingProd = true;
  this.mensaje_loading_prod = this.$t('simulacion.modulo.resultado.temporal.mensajes.aplicando_filtros');

  // 1) aplica datos
  this.datosFiltradosAplicados = this.datosFiltrados.slice();
 // 1b) aplica los filtros de UI al estado aplicado
this.periodoTipoAplicado            = this.periodoTipo;
 this.periodoSeleccionadoAplicado    = [...this.periodoSeleccionado];
this.mesesSeleccionadosAplicado     = [...this.mesesSeleccionados];
this.semanasSeleccionadasAplicado   = [...this.semanasSeleccionadas];
this.diasSeleccionadosAplicado      = [...this.diasSeleccionados];
 await this.$nextTick();
  // 2) fuerza re-mount para asegurar setOption
  this.chartKey = Date.now();
  await this.$nextTick();

  // 3) asegura medida visible
  this.$refs.grafProdTotal?.resize?.();
  window.dispatchEvent(new Event('resize'));

  // 4) respaldo
  this.loadingTimeout = setTimeout(() => {
    if (this.loadingProd) this.loadingProd = false;
  }, 15000);
},
    fmt (n) {
  return Math.round(n ?? 0).toLocaleString(undefined, { maximumFractionDigits: 0 });
},
     onProdRendered() {
 // Solo ocultar loading si todavía está activo
  if (this.loadingProd) {
    this.loadingProd = false;
    clearTimeout(this.loadingTimeout);
  }
},
onProdError(error) {
  console.error("Error en gráfico producción:", error);
  this.loadingProd = false;
  clearTimeout(this.loadingTimeout);
},

async seleccionarHorizonteCompleto () {
  if (this.suspendAutoRender) return;
  this.suspendAutoRender = true;

  try {
    this.periodoTipo = 'mensual';                        // clave interna
    this.aniosSeleccionados = [...this.aniosDisponibles];

    // Selecciona TODOS los meses por ID (0..11) -> la UI mostrará la label traducida
    this.periodoSeleccionado = Array.from({ length: 12 }, (_, i) => i);

    // Limpia semanal
    this.mesesSeleccionados   = [];
    this.semanasSeleccionadas = [];
    this.diasSeleccionados    = [];
  } finally {
    this.$nextTick(() => { this.suspendAutoRender = false; });
  }
},

onH2Rendered() {
  if (this.loadingH2) {
    this.loadingH2 = false;
    clearTimeout(this.h2LoadingTimeout);
  }
},

onH2Error(error) {
  console.error("Error en gráfico H2:", error);
  this.loadingH2 = false;
  clearTimeout(this.h2LoadingTimeout);
},

async cargarGraficoH2Production () {
  if (this.loadingH2) return;
  this.loadingH2 = true;
  this.mensaje_loading_h2 = this.$t?.('mensajes.cargando_grafico') || 'Cargando gráfico...';

  if (!this.showGraficoH2Production) {
    this.showGraficoH2Production = true;
    await this.$nextTick();
  }

  // fuerza re-mount + resize cuando ya es visible
  this.h2ChartKey = Date.now();
  await this.$nextTick();
  this.$refs.grafH2Origen?.resize?.();
  window.dispatchEvent(new Event('resize'));

  // respaldo
  this.h2LoadingTimeout = setTimeout(() => {
    if (this.loadingH2) this.loadingH2 = false;
  }, 10000);
},


    agruparDatosPorPeriodo(campo) {
  const agrupado = {};
  const ordenTrimestres = ['T1','T2','T3','T4'];
const tipo = this.periodoTipoAplicado || 'mensual';

  (this.datosFiltradosAplicados || []).forEach(d => {
    const f = new Date(d.fecha);
    const year = f.getFullYear();
    const mes  = f.getMonth();
    const dia  = f.getDate();

    let clave = '';

   if (tipo === 'anual') {
      clave = `${year}`;

   } else if (tipo === 'trimestral') {
      const t = ordenTrimestres[Math.floor(mes / 3)];
      clave = `${year}-${t}`;
    

   } else if (tipo === 'mensual') {
     clave = `${year}-${String(mes).padStart(2,'0')}`; // ID sortable

   } else if (tipo === 'semanal') {
      const y = String(year).padStart(4,'0');
      const m = String(mes+1).padStart(2,'0');
      const d2= String(dia).padStart(2,'0');
      clave = `${y}-${m}-${d2}`;
    } else {
      clave = d.fecha;
    }

    if (!agrupado[clave]) agrupado[clave] = 0;
    agrupado[clave] += Number(d[campo]) || 0;
  });

  const keys = Object.keys(agrupado);
  const ordenadas = keys.sort((a,b) => {


   if (tipo === 'anual') return Number(a) - Number(b);
   if (tipo === 'mensual') {
      const [ya, ma] = a.split('-'); const [yb, mb] = b.split('-');
      return Number(ya) - Number(yb) || Number(ma) - Number(mb);
    }

   if (tipo === 'trimestral') {
      const [ya, ta] = a.split('-'); const [yb, tb] = b.split('-');
      const ia = ['T1','T2','T3','T4'].indexOf(ta);
      const ib = ['T1','T2','T3','T4'].indexOf(tb);
      return Number(ya) - Number(yb) || ia - ib;
    }

   if (tipo === 'semanal') return a.localeCompare(b);
    return a.localeCompare(b);
  });

  // Labels finales (traducción si mensual)
 const labels = ordenadas.map(k => {
   if (tipo === 'mensual') {
     const [y, mStr] = k.split('-'); const m = Number(mStr);
     const labelMes = this.i18nMeses[m]?.label ?? mStr;
     return `${y}-${labelMes}`;
   }
   return k;
 });

  return {


   labels,
   valores: ordenadas.map(k => Number(agrupado[k].toFixed(2)))
  };
},

    getPeriodos() {
  switch (this.periodoTipo) {
    case 'Mensual':    return this.i18nMeses;
    case 'Trimestral': return this.i18nTrimestres;
    case 'Semanal':    return this.i18nSemanas;
    default:           return [];
  }

},
    periodoToDate(periodoId) {
      // Fallback si no llega 'fecha' desde backend
      const pNumber = parseInt(String(periodoId).substring(1));
      const horasPorDia = 24;
      const dia = Math.floor((pNumber - 1) / horasPorDia) + 1;
      const hora = (pNumber - 1) % horasPorDia;
      const fechaBase = new Date(`${this.datos_generales?.anio_inicio || 2023}-01-01T00:00:00`);
      fechaBase.setDate(fechaBase.getDate() + (dia - 1));
      fechaBase.setHours(hora);
      return fechaBase;
    },
    async simularCargaInicial() {
    this.loading = true;
   this.mensaje_loading = this.$t('simulacion.modulo.resultado.temporal.mensajes.preparando_datos');

    // Simula carga con timeout
    await new Promise(resolve => setTimeout(resolve, 30000));

    this.loading= false;
    this.mountedReady = true;
  }
    
  },
async mounted() {
 console.log('anuales:', this.datos_anuales.length, 'horario:', this.datos_temporales.length);
  
  // Muestra una muestra con valores no cero
  const muestra = this.datos_temporales.find(r => (r.G_H2V || r.G_H2L))
  console.log('[muestra horarios]', muestra)
 await this.simularCargaInicial();
 
},



  watch: {
  datos_generales: {
    immediate: true,
    handler(val) {
      console.log('[H2 DEBUG] prop datos_anuales llegó:', Array.isArray(val) ? val.length : val);
      if (val?.anio_inicio && val?.anio_fin) {
        const anios = [];
        for (let y = val.anio_inicio; y <= val.anio_fin; y++) anios.push(y);
        this.aniosDisponibles = anios;

        
      }
    }
  },
  periodoTipo() {
   if (this.suspendAutoRender) return; 
  this.periodoSeleccionado = [];
  this.mesesSeleccionados = [];
   this.semanasSeleccionadas = [];
   this.diasSeleccionados = [];
 },
  // --- LOG cuando cambian las options de las gráficas ---
    graficaProduccionHidrogeno(opt) {
      console.log('graficaProduccionHidrogeno -> labels:',
               opt?.xAxis?.data?.length || 0,
               'series:', opt?.series?.length || 0);
    },
    graficaH2Production(opt) {
      console.log('graficaH2Production -> labels:',
               opt?.xAxis?.data?.length || 0,
               'series:', opt?.series?.length || 0);
    }
  
},

  components: {
    ComponenteGrafica,
    ComponenteLoading
  }
};
</script>

<style scoped>
.contenedor-personalizado{
  border: 4px solid #bad8f1;
  padding: 30px 15px 10px 15px;
  border-radius: 8px;
  background-color: rgb(241, 247, 252);
}
.tabla-container {
  
  width: 100%;
  overflow-x: auto;       
  text-align: center;
}


.tabla-origen {
  display: inline-block;
}


.tabla-origen :deep(table) {
  width: 100%;  
  /*display: inline-block;*/   
  table-layout: auto;
}


.tabla-origen :deep(th),
.tabla-origen :deep(td) {
  padding: 4px 8px;       
  white-space: nowrap;    
}


.tabla-origen :deep(th:first-child),
.tabla-origen :deep(td.primera-col) {
  width: 140px;           
}
.col-label {
  text-align: left !important; 
  padding-left: 8px;           
}

</style>